import { ShopSelectionWidget } from 'components/FormWidget';

const uiSchema = () => ({
  shop_id: {
    'ui:widget': ShopSelectionWidget,
    'ui:options': {
      initFilter: {
        for_admin: 1,
      },
    },
  },
});

export default uiSchema;
